<template>
  <div class="downLoadBox" v-if="showDownLoad">
    <div class="downLoad">
      <img src="@/assets/img/h5/logo.png" alt />
      <div>
        <div class="info">
          <p class="name">云端美育</p>
          <p class="tip">获取更多服务请前往App体验</p>
        </div>
        <div class="right">
          <span @click="util.downLoad(this)">下载</span>
          <i class="close" @click="close"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showDownLoad: 1,
    };
  },
  mounted() {
    this.showDownLoad = sessionStorage.getItem("showDownLoad")
      ? sessionStorage.getItem("showDownLoad") - 0
      : 1;
  },
  methods: {
    close() {
      this.showDownLoad = 0;
      sessionStorage.setItem("showDownLoad", 0);
    },
  },
};
</script>
<style scoped lang="scss">
.downLoadBox {
  position: relative;
  color: rgba(45, 45, 45, 1);
  overflow: hidden;
  .downLoad {
    background: transparent;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 11px 16px;
    position: relative;
    z-index: 10;
    img {
      width: 40px;
      height: 40px;
    }
    > div {
      flex: 1;
      margin-left: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .info {
        flex: 1;
        margin-right: 12px;
        .name {
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
        }
        .tip {
          font-size: 12px;
          line-height: 17px;
          margin-top: 4px;
        }
      }
      .right {
        span {
          font-size: 14px;
          color: #fff;
          line-height: 20px;
          padding: 6px 16px;
          background: rgba(201, 76, 76, 1);
          border-radius: 16px;
          display: inline-block;
          vertical-align: middle;
        }
        .close {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../assets/img/h5/close_gray.png) no-repeat;
          background-size: 16px 16px;
          vertical-align: middle;
          margin-left: 16px;
        }
      }
    }
  }
}
.downLoadBox::before {
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(210, 208, 208, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  filter: blur(50px);
}
</style>


